import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_SUBSCRIBED_DATA_FEEDS,
  GET_UPDATED_DATA_FEEDS,
  GET_SUBSCRIBED_DATA_FEEDS_SUCCESS,
  GET_UPDATED_DATA_FEEDS_SUCCESS,
  GET_SUBSCRIBED_DATA_FEEDS_FAILURE,
  GET_UPDATED_DATA_FEEDS_FAILURE,
} from '../../../../../store/actionTypes';
import { getData } from '../../../../../api/ApiCommunication';

async function getSubscribedFeedData(params?: any): Promise<any> {
  const response = await getData('GetSubscribedDataFeed');
  return response;
}

/**
 * Saga to get AvailableFeed Data from API.
 */
export function* getSubscribedFeedDataSaga(action: any) {
  try {
    const { data } = yield call(getSubscribedFeedData, action.params);
    yield put({
      type: GET_SUBSCRIBED_DATA_FEEDS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_SUBSCRIBED_DATA_FEEDS_FAILURE,
      error,
    });
  }
}

export function* waitForSubscribedFeedData() {
  yield takeLatest(GET_SUBSCRIBED_DATA_FEEDS, getSubscribedFeedDataSaga);
}

/**
 * Saga to get AvailableFeed Data from API.
 */
export function* getUpdatedFeedDataSaga(action: any) {
  try {
    const { data } = yield call(getSubscribedFeedData, action.params);
    yield put({
      type: GET_UPDATED_DATA_FEEDS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_UPDATED_DATA_FEEDS_FAILURE,
      error,
    });
  }
}

export function* waitForUpdatedFeedData() {
  yield takeLatest(GET_UPDATED_DATA_FEEDS, getUpdatedFeedDataSaga);
}
